export default __webpack_public_path__ + "static/media/glass_compared.59bbd366.JPG";